import React, { useState } from 'react';

export default function PhoneAlertsPage() {
  const [formData, setFormData] = useState({ name: '', phone: '', topics: [] });
  const [submitted, setSubmitted] = useState(false);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      if (checked) {
        return { ...prev, topics: [...prev.topics, value] };
      } else {
        return { ...prev, topics: prev.topics.filter(topic => topic !== value) };
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Submitted:', formData);
    setSubmitted(true);
    setFormData({ name: '', phone: '', topics: [] });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-200">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Subscribe to Phone Alerts</h1>
        <p className="text-center text-gray-600 mb-8">Get timely tips and information on your phone via SMS.</p>
        {submitted ? (
          <div className="text-center p-4 bg-green-100 text-green-800 rounded-lg">
            Thank you for subscribing! You will start receiving alerts soon.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="name" className="block text-gray-700 font-semibold mb-2">Full Name</label>
              <input type="text" id="name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required />
            </div>
            <div className="mb-6">
              <label htmlFor="phone" className="block text-gray-700 font-semibold mb-2">Phone Number</label>
              <input type="tel" id="phone" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required pattern="[0-9]{10}" placeholder="10-digit mobile number" />
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-semibold mb-2">Topics of Interest</label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {['Farming Tips', 'Market Prices', 'Weather Alerts', 'Govt. Schemes', 'Health & Nutrition'].map(topic => (
                  <label key={topic} className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 cursor-pointer">
                    <input type="checkbox" value={topic} onChange={handleCheckboxChange} className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500" />
                    <span>{topic}</span>
                  </label>
                ))}
              </div>
            </div>
            <button type="submit" className="w-full bg-green-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-green-700 transition-colors">Subscribe Now</button>
          </form>
        )}
      </div>
    </div>
  );
}


